<template>
  <Modal
    v-model="state"
    :title="plustitle"
    :mask-closable="false"
    width="540"
    class-name="vertical-center-modal">
    <Form :label-width="140">
      <FormItem label="月份" v-if="property(info.month)">
        <DatePicker
          type="month"
          v-model="month"
          :disabled="edit"
          :options="datetimeOption"
          editable
          placeholder="请选择"
          style="width: 180px"
          @on-change="setMonth">
        </DatePicker>
      </FormItem>
      <FormItem label="类型" v-if="property(info.type)">
        <Select v-model="type" :disabled="edit" style="width:280px" placeholder="请选择类型">
          <Option :value="1" :key="1">图片</Option>
          <Option :value="2" :key="2">视频</Option>
        </Select>
      </FormItem>
      <FormItem label="奖金起算金额" v-if="property(info.threshold)">
        <Input
          v-model.trim="threshold"
          placeholder="请输入大于0，小于99999999.00，最多2位小数"
          style="width: 280px"
          @on-blur="toFloat('threshold', threshold, true)" />
      </FormItem>
    </Form>
    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('input', false)">取消</Button>
        <Button type="primary" :loading="loading" @click="$emit('on-save', {month, threshold, type})">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>
<script>
import { mul, div } from '@/common/js/api'
import { formatDate, isEmpty, trim } from '@/common/js/utils'
export default {
  name: 'setDesign',
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean,
      default () {
        return false
      }
    },
    datetimeOption: {
      type: Object
    },
    info: {
      type: Object
    },
    edit: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  computed: {
    state: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    property () {
      return val => val !== undefined
    },
    plustitle () {
      return `${this.edit ? '修改' : '新增'}${this.title}`
    }
  },
  watch: {
    info: {
      handler (nVal) {
        this.updateInfo(nVal)
      },
      deep: true
    }
  },
  methods: {
    updateInfo (info) {
      const { month, threshold, type } = info
      this.month = month && formatDate(new Date(month), 'yyyy-MM')
      this.threshold = threshold
      this.type = type
    },
    setMonth (val) {
      this.month = val
    },
    toFloat (key, val, fixed) {
      val = trim(val)
      if (isEmpty(val)) return
      if (fixed) {
        val = parseFloat(val)
        if (!isNaN(val)) {
          val = mul(val, 100)
          val = div(Math.floor(val), 100)
        } else val = ''
      } else {
        val = parseInt(val)
        isNaN(val) && (val = '')
        val < 0 && (val = 0)
      }
      this[key] = val
    }
  },
  data () {
    return {
      month: '',
      threshold: '',
      type: ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.updateInfo(this.info)
    })
  }
}
</script>
